module.exports = __webpack_public_path__ + "static/media/sendgrid-logo.b6468cc6.png";